<template>
  <Modal id="poll-question" modifier="poll" #default="{ close, options }">
    <div class="close" @click="close">
      <SvgIcon name="close" />
    </div>
    <template v-if="options">
      <div class="subtitle">
        <template v-if="options.isAnonymous || options.anonymously">{{ $t('ModalPollQuestion.title') }}</template>
        <template v-else>{{ $t('ModalPollQuestion.subtitle') }}</template>
      </div>
      <h2>{{ options.title }}</h2>

      <SelectList
        :options="options.variations"
        :selected="selected"
        @onSelect="selected = $event"
        :your-answer="options.free_answer"
      />

      <!-- todo - any rules when to show ? -->
      <!-- <div class="toggle">
        <Toggle label="Ответить анонимно" :value="anonymousReply" @onChange="(val) => (anonymousReply = val)" />
      </div> -->

      <div class="actions">
        <!-- <button @click="getNextPoll(options.id)">Get dev next poll</button> -->
        <button class="transparent" @click="handleSkip(options.id)" v-if="!options.mandatory">
          {{ $t('ModalPollQuestion.skip') }}
        </button>
        <button @click="handleSubmit(options.id)" class="blue">{{ $t('submit') }}</button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import { withUi } from '@/components/ui'
import Modal from '@/components/modals/Modal'

export default {
  name: 'ModalPollQuestion',
  components: { Modal },
  mixins: [withUi],
  data() {
    return {
      selected: null,
    }
  },
  computed: {
    ...mapState(['modal']),
    ...mapGetters('polls', ['isAnonymous', 'getNextPoll']),
  },
  methods: {
    reset() {
      this.selected = null
    },
    async handleSkip(id) {
      await this.cancelPoll({
        params: {
          id,
        },
        data: {
          anonymously: this.isAnonymous,
        },
      })
        .then((res) => {
          // this.$toast({ title: `skipped ${res.data.id}` })
          const nextPoll = this.getNextPoll(+id)
          if (nextPoll) {
            this.openModal({ name: 'poll-question', options: nextPoll })
          } else {
            this.closeModal()
          }
        })
        .catch((err) => {
          this.$toast({ type: 'error', title: err?.response?.data?.message || err })
          console.warn(err)
        })
    },
    async handleSubmit(id) {
      await this.votePoll({
        params: {
          id,
        },
        data: {
          vote: this.selected,
          anonymously: this.isAnonymous,
        },
      })
        .then((res) => {
          this.selected = null
          // this.$toast({ title: `voted ${res.data.id}` })
          const nextPoll = this.getNextPoll(+id)
          console.log(nextPoll)
          if (nextPoll) {
            this.openModal({ name: 'poll-question', options: nextPoll })
          } else {
            this.closeModal()
          }
        })
        .catch((err) => {
          this.$toast({ type: 'error', title: err?.response?.data?.message || err })
          console.warn(err)
        })
    },
    ...mapMutations(['openModal', 'closeModal']),
    ...mapActions('polls', ['votePoll', 'cancelPoll']),
  },
  watch: {
    modal(val) {
      if (val === false) {
        this.reset()
      }
    },
  },
}
</script>

<style lang="scss">
#modal-poll-question {
  .close {
    position: absolute;
    z-index: 3;
    top: 20px;
    right: 10px;
    color: $dark;
    font-size: 0;
    padding: 10px;
    cursor: pointer;
    transition: color 0.25s $ease;
    .svg-icon {
      font-size: 14px;
    }
    &:hover {
      color: $primary;
    }
  }
  h2 {
    font-size: 14px;
    margin-bottom: 32px;
    text-align: left;
  }
  .actions {
    margin-top: 60px;
    button {
      height: 40px;
      &.transparent {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.subtitle {
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 17px;
  color: $dark;
}

.toggle {
  margin-top: -14px;
  margin-bottom: 14px;
}
</style>
